<div class="flex align-items-center justify-content-center w-full pb-8 mb-8" *ngIf="loading">
	<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>

<div *ngIf="!loading" class="layout-content">
	<div class="grid">
		<!-- FILTER -->
		<div class="col-12" [formGroup]="filterForm">
			<div class="flex justify-content-around w-full">
				<div class="flex align-items-center">
					<p-checkbox [binary]="true" formControlName="statusReceiver" [binary]="true" styleClass="mx-2"
						(onChange)="$event.checked"></p-checkbox>
					<p-tag [value]="'INVITATIONS_RECEIVED' | translate" severity="info" icon="pi cm-user"></p-tag>
				</div>
				<div class="flex align-items-center">
					<p-checkbox [binary]="true" formControlName="statusSender" [binary]="true" styleClass="mx-2"
						(onChange)="$event.checked"></p-checkbox>
					<p-tag [value]="'INVITATIONS_SENT' | translate" severity="warning" icon="pi cm-mail"></p-tag>
				</div>
			</div>
		</div>
		<div class="col-12 pt-0">
			<p-table dataKey="Id" [value]="invitationsList" [paginator]="true" [totalRecords]="totalRecords"
				[loading]="loading" [rows]="pageSize" [showCurrentPageReport]="true" [lazy]="true" (onPage)="onPageChange($event)"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="header">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'TYPE' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'INVITATION_DETAILS' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'SENDER' | translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">
								{{ 'EMAIL' | translate }}
							</div>
						</th>
						<!-- ACTIONS BUTTONS -->
						<th></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-invitation>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'TYPE' | translate }}</span>
							<div class="flex align-items-center justify-content-center gap-2">
								<div [class]="getInvitationsTypeIcon(invitation)" class="text-lg"></div>
								<div>{{ getInvitationsTypeTxt(invitation) | translate | truncate:[30]}}</div>
							</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'INVITATION_DETAILS' | translate }}</span>{{
							getInvitationsDetails(invitation) }}
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'SENDER' | translate }}</span>
							<p-tag *ngIf="receiverInvitation(invitation)" [icon]="getSenderTypeIcon(invitation)" [value]="invitation.CreatorFirstName + ' ' + invitation.CreatorLastName | translate | truncate:[32]"
										[severity]="getSenderSeverity(invitation)"></p-tag>
							<p-tag *ngIf="!receiverInvitation(invitation)" icon="pi cm-mail" [value]="'INVITATION_SUCCESS' | translate" severity="warning"></p-tag>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'EMAIL' | translate }} </span>
							{{ getEmailInvitation(invitation) | truncate:[32] }}
						</td>
						<td>
							<div *ngIf="receiverInvitation(invitation)" class="flex flex-row justify-content-center align-items-center gap-1" [class]="underTablet() ? 'w-full' : ''">
								<button type="button" pButton pRipple label="{{ 'ACCEPT' | translate }}"
									class="p-button-success font-normal" (click)="acceptInvite(invitation)"
									icon="pi cm-check">
								</button>
								<button type="button" pButton pRipple label="{{ 'REJECT' | translate }}"
									class="p-button-danger font-normal" (click)="rejectInvite(invitation)"
									icon="pi cm-cancel">
								</button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
			class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
		</button>
	</div>

	<p-confirmDialog #confDialog>
		<ng-template pTemplate="footer">
			<div class="col-12 flex justify-content-center">
				<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
					(click)="confDialog.accept()">
				</button>
				<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
					(click)="confDialog.reject()">
				</button>
			</div>
		</ng-template>
	</p-confirmDialog>
</div>